import { IconCircleXNotFilled } from './IconCircleXNotFilled'

export default IconCircleXNotFilled
